import { useRouteRefParams } from '@backstage/frontend-plugin-api';
import { entityRouteRef } from '@backstage/plugin-catalog-react';
import { ResourcesTab } from '../CatalogTabs';
import { CloudResourcesContextProvider, PageType } from '../Providers';

/**
 * Project resources tab. Shares the resources tab UI with account pages and
 * adds the Account dimension through the provider's PROJECT mode (account
 * picker + account column/grouping).
 */
export const ProjectCloudResourcesTab = () => {
  const { name } = useRouteRefParams(entityRouteRef);

  return (
    <CloudResourcesContextProvider
      pageType={PageType.PROJECT}
      entityName={name}
    >
      <ResourcesTab />
    </CloudResourcesContextProvider>
  );
};
